import sendRequest from "./sendRequest";

export const startProvisioning = (unique_id, serial_number) => {
    const data = {
        'unique_id': unique_id,
        'serial_number': serial_number
    }
    return sendRequest("/start_provisioning", "POST", true, data);
}
